import request from './../../utilities/request';
import localStorageToken from './../../utilities/storage';

function get(page, query) {
  return request({
    url:    `/autogestion/list/page/${ page }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET',
    params:  query
  });
}

function create(values) {
  return request({
    url:    '/autogestion/save',
    headers: {'Authorization': localStorageToken()},
    method: 'POST',
    data:   values
  });
}

function update(id, values) {
  return request({
    url:    `/autogestion/update/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'PUT',
    data:   values
  });
}

function find(id) {
  return request({
    url:    `/autogestion/overview/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

function remove(id) {
  return request({
    url:    `/autogestion/remove/${ id }`,
    headers: {'Authorization': localStorageToken()},
    method: 'DELETE'
  });
}

function reportFolderAttachments() {
  return request({
    url:    `/autogestion/report/folder-size`,
    headers: {'Authorization': localStorageToken()},
    method: 'GET'
  });
}

const AutogestionService = {
  get, create, update, remove, find, reportFolderAttachments
}

export default AutogestionService;
